import axios from '../../axios'

// 分页查询
export const findPage = () => {
    return axios({
        url: '/district/list',
        method: 'post'
    })
}



// WEBPACK FOOTER //
// ./src/http/modules/district/district.js